module.exports = __webpack_public_path__ + "images/category_lp/jewel/new/store_images/2_5e1d144e84e3f8a51c50209601e4d127.png";